Auth = require 'db/auth'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
track = require 'debug/track'
dueSoonInfoTemplate = require 'views/templates/due_soon_info'

module.exports = class BoardsPageDueSoonInfoView extends View
  viewTitleKey: 'due soon info'
  tagName: 'div'
  className: ''

  events:
    'click .js-disable-due-soon': 'disableDueSoon'

  render: ->
    @$el.html dueSoonInfoTemplate
      memberId: @options.memberId
    @

  disableDueSoon: (e) ->
    Util.stop(e)
    Auth.me().dismiss('dueSoonExperiment')
    track('Boards View', 'Due Soon', 'Clicked dismiss')
    PopOver.popView()
    return



// WEBPACK FOOTER //
// ./app/scripts/views/member/boards-page-due-soon-info-view.coffee